module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/tebex.5e05a5d0.svg";